import { PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Button } from "V2.0/common/button";
import { defaultWaitForCallbackExpectedField } from "../../../Models/WaitForCallback/waitForCallbackExpectedField";
import WaitForCallbackExpectedFieldTable from "./WaitForCallbackExpectedFieldTable";
import WaitForCallbackExpectedFieldDialog from "./WaitForCallbackExpectedFieldDialog";

export default WaitForCallbackExpectedFields;

function WaitForCallbackExpectedFields(props) {
  const { expectedFields, onUpdateExpectedFields } = props;

  const [expectedFieldDialog, setExpectedFieldDialog] = useState({
    mode: undefined,
    expectedFieldIdx: -1,
    expectedField: undefined,
  });

  const handleOpenAddExpectedField = () => {
    setExpectedFieldDialog({
      mode: "add",
      expectedFieldIdx: -1,
      expectedField: defaultWaitForCallbackExpectedField,
    });
  };

  const handleOpenEditExpectedField = (expectedField, expectedFieldIdx) => {
    setExpectedFieldDialog({
      mode: "edit",
      expectedField,
      expectedFieldIdx,
    });
  };

  const handleCloseExpectedField = () => {
    setExpectedFieldDialog({
      mode: undefined,
      expectedField: undefined,
      expectedFieldIdx: -1,
    });
  };

  const addExpectedField = (expectedField) => {
    const updatedExpectedFields = [...expectedFields, expectedField];
    onUpdateExpectedFields(updatedExpectedFields);
  };

  const updateExpectedField = (expectedField, expectedFieldIdx) => {
    const updatedExpectedFields = expectedFields.toSpliced(
      expectedFieldIdx,
      1,
      expectedField,
    );
    onUpdateExpectedFields(updatedExpectedFields);
  };

  const removeExpectedField = (expectedFieldIdx) => {
    const updatedExpectedFields = expectedFields.toSpliced(expectedFieldIdx, 1);
    onUpdateExpectedFields(updatedExpectedFields);
  };

  return (
    <>
      <div className="flex flex-col gap-y-4">
        <div className="flex justify-between items-center">
          <p className="text-sm font-medium">Expected Fields</p>
          <Button
            plain
            onClick={handleOpenAddExpectedField}
          >
            <PlusIcon /> Add
          </Button>
        </div>
        <div>
          <WaitForCallbackExpectedFieldTable
            expectedFields={expectedFields}
            onEditExpectedField={handleOpenEditExpectedField}
            onRemoveExpectedField={removeExpectedField}
          />
        </div>
      </div>
      {expectedFieldDialog.mode && (
        <WaitForCallbackExpectedFieldDialog
          onClose={handleCloseExpectedField}
          expectedFieldDialog={expectedFieldDialog}
          onAddExpectedField={addExpectedField}
          onUpdateExpectedField={updateExpectedField}
        />
      )}
    </>
  );
}
